// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing--pricing--3ZZ8J","pricingTable":"Pricing--pricingTable--2ieuB","price":"Pricing--price--1KPou"};